
import { Component, Vue } from 'vue-property-decorator'
import PasswordReminder from '@/components/templates/password/PasswordReminder.vue'
import { PasswordsApi } from '@/api/methods/auth/PasswordsApi'

/**
 * パスワード再設定手続きページ
 */
@Component({
  components: {
    PasswordReminder,
  },
})
export default class StudentPasswordReminder extends Vue {
  /**
   * 送信ボタン押下時処理
   *
   * @param loginId ログインID
   */
  public async eventSubmit(loginId: string): Promise<void> {
    this.$loading.start()

    // パスワード再設定要求APIを実行・メールが送信される
    await PasswordsApi.requestReset(loginId)

    this.$loading.complete()

    await this.$router.push('/student/password/reminder/complete')
  }
}
